export const runningAsStandalone = (): boolean => {
  return window.matchMedia('(display-mode: standalone)').matches;
};
